<p-confirmPopup></p-confirmPopup>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>

<div class="super-admin-outer">
    <div class="card breadcrumbs">
        <div class="common-justify-wrap card-container purple-container">
      
          <ul class="list-none breadcrumbs-outer">
            <li class="active-dashboard">
              <a [routerLink]="['/manager/dashboard']" class="common-underline">Dashboard</a>
            </li>
            <li class="px-2 breadcrumbs-divider">
              <span>|</span>
            </li>
      
            <li class="current-link">
              <span class="line-height-3">Parking Locations</span>
            </li>
          </ul>
          <p-button  *ngIf="createParkingCheck"  (onClick)="createParking()" label="Add New Location" styleClass="p-button-outlined mb-0"></p-button>
        </div>
      </div>

    <div class="dashboard-table super-offer-bg">
        <div class="top-list">
            <div class="custom-search">
                <span class="p-input-icon-right">
                    <input type="text" [(ngModel)]="searchQuery"  pInputText placeholder="Search Parking Location by name or address" (keydown.enter)="getParkingLotsByManagerId('search')"/>
                    <p-button class="apply-coupon" (onClick)="getParkingLotsByManagerId('search')" label="Search"></p-button>
                </span>
            </div>
           </div>

        <div class="card parking-list"  id="tbl-parking-list">

            <p-table [value]="parkingList" [resizableColumns]="false">
                <ng-template pTemplate="header">
                    <tr>
                    
                      <th scope="col">Parking Location
                      <th scope="col" class="custom-addres">Address
                      <th scope="col">Total Spots
                        <th scope="col"><div class="occupancy-outer"><span>Occupancy %</span><app-tooltip [addClass]="'custom-tooltip-width'" [tooltipMessage]="occupancyTooltipMsg"></app-tooltip></div> </th>
                      <th scope="col">Status
                      </th>
                      <th scope="col" *ngIf="showActions">Action
                      </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr class="border12">
                        <td>{{ rowData.name }}</td>

                        <td>{{ rowData.parkingLocation}}</td>
                        
                        <td><label *ngIf="rowData.isComingSoon == false" >{{ rowData.numberOfSlots }}</label></td>
                        <td> <div class="occupancy-progressbar">
                          <p-progressBar [value]="rowData?.occupancyRate" [color]="'#03C539'" [showValue]="false"></p-progressBar>
                          <p>{{ rowData?.occupancyRate || 0}}%</p>
                        </div>
                      </td>
                        <td >
                          <div class="active-toggle" *ngIf="!rowData.isDeleted; else disable " [ngClass]="{'last-col':!showActions}">
                            <label [for]="'togBtn_' + rowData.id" *ngIf="!rowData.isComingSoon" class="switch">
                              <input type="checkbox" [id]="'togBtn_' + rowData.id" [checked]="rowData.isActive"
                                (change)="updateParkingLotStatus(rowData.id)">
                              <div class="slider round">
                                <span class="on">Active</span>
                                <span class="off">Inactive</span>
                              </div>
                            </label>
                            <label *ngIf="rowData.isComingSoon === true" class="coming-soon">Coming Soon</label>
                          </div>
                          <ng-template #disable>
                            <div class="delete-border">
                              <span>
                                Suspended
                              </span>
                            </div>
                        </ng-template>
                          </td>
                        <td *ngIf="showActions">
                            <div class="export-btn">

                                <div>
                                    <img (click)="activeItem = rowData;showData(rowData);menu.toggle($event);"
                                        src="assets/images/dashboard-dot.svg" alt="" />
                                </div>

                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td class="no-record" colspan="7">
                            No Record Found
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            
        </div>
            <div class="card common-content-end custom-pagination1" >
         
                <p-paginator [first]="first"  [rows]="itemsPerPage"  [totalRecords]="totalItems"
                  (onPageChange)="onPageChange($event)"></p-paginator>
              </div>
            </div>

        </div> 
        <div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>
        </div>
